/*
 *
 * Artifactory is a binaries repository manager.
 * Copyright (C) 2018 JFrog Ltd.
 *
 * Artifactory is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 * Artifactory is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with Artifactory.  If not, see <http://www.gnu.org/licenses/>.
 *
 */
import TOOLTIP from '../../../../constants/artifact_tooltip.constant';
import MESSAGES from '../../../../constants/configuration_messages.constants';
import DestinationsEffectivePermissionModel from '../../../../models/DestinationsEffectivePermissionModel';

export class AdminSecurityGroupFormController {
    constructor($scope, $state, $stateParams, $timeout, $q, JFrogGridFactory, GroupsDao, UserDao, GroupPermissionsDao,
                commonGridColumns, ArtifactoryModelSaver, RepositoriesDao, JFrogTableViewOptions, DistributionPermissionsDAO, $window,
                AppContext, PipelinesPermissionsDao, ArtifactoryFeatures, ProjectAdminDao, JFrogNotifications) {
        this.DEFAULT_REALM = "artifactory";
        this.$scope = $scope;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$timeout = $timeout;
        this.$q = $q;
        this.repositoriesDao = RepositoriesDao;
        this.userDao = UserDao.getInstance();
        this.groupsDao = GroupsDao.getInstance();
        this.disributionPermissionsDAO = DistributionPermissionsDAO.Resource;
        this.groupPermissionsDao = GroupPermissionsDao.getInstance();
        this.pipelinesPermissionsDao = PipelinesPermissionsDao.getInstance();
        this.projectAdminDao = ProjectAdminDao.getInstance();
        this.artifactoryGridFactory = JFrogGridFactory;
        this.reposPermissionsOptions = {};
        this.buildsPermissionsOptions = {};
        this.commonGridColumns = commonGridColumns;
        this.ArtifactoryModelSaver = ArtifactoryModelSaver.createInstance(this, ['groupdata']);
        this.input = {};
        this.MESSAGES = MESSAGES.admin.security.groups.groupForm;
        this.TOOLTIP = TOOLTIP.admin.security.groupForm;
        this.JFrogTableViewOptions = JFrogTableViewOptions;
        this.$window = $window;
        this.AppContext = AppContext;
        this.features = ArtifactoryFeatures;
        this.nameCellTemplate = require('./permission.name.template.html');
        this.getEffectivePermissionSwitchTabs();
        this.JFrogNotifications = JFrogNotifications

        if ($stateParams.groupname) {
            this.mode = 'edit';
            this.groupname = $stateParams.groupname;
            this.title = 'Edit ' + this.groupname + ' Group';
            this._getGroupData();
            this._createGrid();
            this._getPermissions();
        }
        else {
            this.mode = 'create';
            this.title = 'Add New Group';
            this.groupdata = {
                watchManager: false,
                reportsManager: false,
                policyManager: false
            };
            this.saveLastNewUsersCheckbox = false;
        }

        this._getAllRepos();
        this._getAllUsers();

    }

    $onInit() {
        this.projectAdmin = false;
        this.entityType = 'group';
        if(this.groupname && this.shouldShowProjectAdminRole()) { // in case mode is 'edit' and not 'create'
            this.fetchIsProjectAdmin();
        }
    }

    shouldShowProjectAdminRole() {
        return !this.features.isNoLicenseInstalled() && !this.features.isNonCommercial();
    }

    fetchIsProjectAdmin() {
        const { groupname: entityName, entityType } = this;
        this.projectAdminDao.isProjectAdmin({ entityType, entityName }).$promise.then(({ data }) => {
            if(this.groupdata.adminPrivileges){
                this.projectAdmin = true;
            }else{

                this.projectAdmin = data;
            }
        });
    }

    toggleProjectAdmin() {
        const entityName = this.groupdata.name;
        const { entityType } = this;
        let method = this.projectAdminDao.unsetEntityAsProjectAdmin;
        if (this.projectAdmin) {
            method = this.projectAdminDao.setEntityAsProjectAdmin;
        }
        method({}, { entityType, entityName }).$promise
            .then().catch(({ data: error }) => {
            console.error(error);
            window.store.dispatch('CREATE_NOTIFICATION', { error });
        });
    }
    setProjectAdminToggledFlag() {
        this.wasProjectAdminRoleChanged = true;
    }

    getEffectivePermissionSwitchTabs() {
        this.switchOptions = ['Repositories', 'Builds'];
        if (this.AppContext.hasPlatformLicense()) {
            this.switchOptions = this.switchOptions.concat(['Release Bundles']);
        }
        if (this.AppContext.hasDistribution() && this.AppContext.hasPlatformLicense()) {
            this.switchOptions = this.switchOptions.concat(['Destinations']);
        }
        if (this.AppContext.hasPipelines()) {
            this.switchOptions = this.switchOptions.concat(['Pipelines']);
        }
    }

    _getAllRepos() {
        this.reposData = {};
        this.repositoriesDao.getRepositories({type:'local'}).$promise
            .then((data) => {
                this.reposData.locals = _.map(data,(r)=>{return r.repoKey;});
            });
        this.repositoriesDao.getRepositories({type:'remote'}).$promise
            .then((data) => {
                this.reposData.remotes = _.map(data,(r)=>{return r.repoKey;});
            });
        this.repositoriesDao.getRepositories({type:'distribution'}).$promise
            .then((data) => {
                this.reposData.dists = _.map(data,(r)=>{return r.repoKey;});
            });
    }

    _getGroupData() {
        this.groupsDao.getSingle({name: this.groupname}).$promise.then((data) => {
            this.groupdata = data.data;
            this.isScimGroup = this.groupdata.realm === 'scim';
            this.saveLastNewUsersCheckbox = this.groupdata.newUserDefault;
            this.ArtifactoryModelSaver.save();
        });
    }

    _getAllUsers() {
        this.userDao.getAll().$promise.then((data)=> {
            this.usersData = data;
            this.usersList = _.map(data, (user)=> {
                return user.name;
            });
            this.userDndTemplate = `<div style="min-width:200px">
                                        {{getItemInfo().text}}
                                        <i ng-if="userScope.GroupForm.userIsAdmin(getItemInfo().text)"
                                            jf-tooltip="Admin Privileges"
                                            class="icon icon-admin-new pull-left"></i>
                                        <i ng-if="!userScope.GroupForm.userIsAdmin(getItemInfo().text)"
                                            class="icon icon-blank pull-left"></i>
                                    </div>`
        });
    }

    userIsAdmin(user){
        return _.find(this.usersData,(userData)=>{
            return  userData.name === user && (userData.admin === true || userData.groupAdmin);
        });
    }

    _createGrid() {
        // TODO: Hide manage permissions if not default project
        this.initRepositoriesPermissions();
        this.initBuildsPermissions();
        this.initBundlesPermissions();
        this.initDestinationsPermissions();
        this.initPipelinesPermissions();
    }

    initRepositoriesPermissions() {
        this.reposPermissionsOptions = new this.JFrogTableViewOptions(this.$scope);
        this.reposPermissionsOptions.setColumns(this.getRepoPermissionCloumns());
        this.reposPermissionsOptions.setRowsPerPage(5);
        this.reposPermissionsOptions.setEmptyTableText('No Repositories Permissions were configured.');
        this.reposPermissionsOptions.setObjectName('Permission');
        this.reposPermissionsOptions.sortBy('permissionName');
        this.reposPermissionsOptions.reverseSortingDir();
    }

    initBuildsPermissions() {
        this.buildsPermissionsOptions = new this.JFrogTableViewOptions(this.$scope);
        this.buildsPermissionsOptions.setColumns(this.getBuildsPermissionsColumns());
        this.buildsPermissionsOptions.setRowsPerPage(5);
        this.buildsPermissionsOptions.setEmptyTableText('No Builds Permissions were configured.');
        this.buildsPermissionsOptions.setObjectName('Permission');
        this.buildsPermissionsOptions.sortBy('permissionName');
        this.buildsPermissionsOptions.reverseSortingDir();
    }

    initBundlesPermissions() {
        this.bundlesPermissionsOptions = new this.JFrogTableViewOptions(this.$scope);
        this.bundlesPermissionsOptions.setColumns(this.getBundlesPermissionsColumns());
        this.bundlesPermissionsOptions.setRowsPerPage(5);
        this.bundlesPermissionsOptions.setEmptyTableText('No Release Bundle Permissions were configured.');
        this.bundlesPermissionsOptions.setObjectName('Permission');
        this.bundlesPermissionsOptions.sortBy('permissionName');
        this.bundlesPermissionsOptions.reverseSortingDir();
        this.bundlesPermissionsOptions.setData([]);
    }

    initDestinationsPermissions() {
        this.destinationsPermissionsOptions = new this.JFrogTableViewOptions(this.$scope);
        this.destinationsPermissionsOptions.setColumns(this.getDestinationsPermissionsColumns());
        this.destinationsPermissionsOptions.setRowsPerPage(5);
        this.destinationsPermissionsOptions.setEmptyTableText('No Destination Permissions were configured.');
        this.destinationsPermissionsOptions.setObjectName('Permission');
        this.destinationsPermissionsOptions.sortBy('permissionName');
        this.destinationsPermissionsOptions.reverseSortingDir();
        this.destinationsPermissionsOptions.setData([]);
    }

    initPipelinesPermissions() {
        this.pipelinesPermissionsOptions = new this.JFrogTableViewOptions(this.$scope);
        this.pipelinesPermissionsOptions.setColumns(this.getPipelinesPermissionsColumns());
        this.pipelinesPermissionsOptions.setRowsPerPage(5);
        this.pipelinesPermissionsOptions.setEmptyTableText('No Pipeline Sources Permissions were configured.');
        this.pipelinesPermissionsOptions.setObjectName('Permission');
        this.pipelinesPermissionsOptions.sortBy('permissionName');
        this.pipelinesPermissionsOptions.reverseSortingDir();
        this.pipelinesPermissionsOptions.setData([]);
    }

    onNameClick({permissionName}) {
        this.$window.$vueRouter.push({
            name: 'admin.management.permissions.edit',
            params: {permissionName}
        });
    }

    getRepoPermissionCloumns() {
        return [
            {
                field: "permissionName",
                header: "Permission Target",
                cellTemplate: this.nameCellTemplate,
                width:'20%'
            },
            {
                field: "repoKeys",
                header: "Repositories",
                cellTemplate: this.JFrogTableViewOptions
                    .cellTemplateGenerators.listableColumn('row.entity.reposList','row.entity.permissionName','row.entity.repoKeysView',true),
                width:'25%',
                filterable: false
            },
            {
                field: "effectivePermission.read",
                cellTemplate: this.JFrogTableViewOptions
                    .cellTemplateGenerators.booleanColumn('row.entity.effectivePermission.read'),
                header: "Read",
                width:'8%',
                filterable: false
            },
            {
                field: "effectivePermission.deploy",
                cellTemplate: this.JFrogTableViewOptions
                    .cellTemplateGenerators.booleanColumn('row.entity.effectivePermission.deploy'),
                header: "Deploy/Cache",
                width:'14%',
                filterable: false
            },
            {
                field: "effectivePermission.delete",
                cellTemplate: this.JFrogTableViewOptions
                    .cellTemplateGenerators.booleanColumn('row.entity.effectivePermission.delete'),
                header: "Delete/Overwrite",
                width:'15%',
                filterable: false
            },
            {
                field: "effectivePermission.annotate",
                cellTemplate: this.JFrogTableViewOptions
                    .cellTemplateGenerators.booleanColumn('row.entity.effectivePermission.annotate'),
                header: "Annotate",
                width:'9%',
                filterable: false
            },
            {
                field: "effectivePermission.managedXrayMeta",
                header: "Manage Xray Meta",
                cellTemplate: this.JFrogTableViewOptions
                    .cellTemplateGenerators.booleanColumn('row.entity.effectivePermission.managedXrayMeta'),
                width: '20%',
                filterable: false,
                isVisible: () => this.AppContext.hasXray() && this.AppContext.hasXrayLicense()
            },
            {
                field: "effectivePermission.managed",
                cellTemplate: this.JFrogTableViewOptions
                    .cellTemplateGenerators.booleanColumn('row.entity.effectivePermission.managed'),
                header: "Manage",
                width:'9%',
                filterable: false
            }
        ]
    }

    getBuildsPermissionsColumns() {
        return [
            {
                field: "permissionName",
                header: "Permission Target",
                cellTemplate: this.nameCellTemplate,
                width: '35%'
            },
            {
                field: "effectivePermission.principal",
                header: "Applied To",
                width: '40%'
            },
            {
                field: "effectivePermission.read",
                cellTemplate: this.JFrogTableViewOptions
                    .cellTemplateGenerators.booleanColumn('row.entity.effectivePermission.read'),
                header: "Read",
                width:'15%',
                filterable: false
            },
            {
                field: "effectivePermission.delete",
                cellTemplate: this.JFrogTableViewOptions
                    .cellTemplateGenerators.booleanColumn('row.entity.effectivePermission.delete'),
                header: "Delete",
                width:'15%',
                filterable: false
            },
            {
                field: "effectivePermission.annotate",
                cellTemplate: this.JFrogTableViewOptions
                    .cellTemplateGenerators.booleanColumn('row.entity.effectivePermission.annotate'),
                header: "Annotate",
                width:'15%',
                filterable: false
            },
            {
                field: "effectivePermission.deploy",
                cellTemplate: this.JFrogTableViewOptions
                    .cellTemplateGenerators.booleanColumn('row.entity.effectivePermission.deploy'),
                header: "Deploy",
                width:'15%',
                filterable: false
            },
            {
                field: "effectivePermission.manageXrayMeta",
                header: "Manage Xray Meta",
                cellTemplate: this.JFrogTableViewOptions
                    .cellTemplateGenerators.booleanColumn('row.entity.effectivePermission.managedXrayMeta'),
                width: '20%',
                filterable: false,
                isVisible: () => this.AppContext.hasXray() && this.AppContext.hasXrayLicense()
            },
            {
                field: "effectivePermission.managed",
                cellTemplate: this.JFrogTableViewOptions
                    .cellTemplateGenerators.booleanColumn('row.entity.effectivePermission.managed'),
                header: "Manage",
                width:'15%',
                filterable: false
            },
        ]
    }

    getBundlesPermissionsColumns() {
        return [
            {
                field: 'permissionName',
                header: 'Permission Target',
                cellTemplate: this.nameCellTemplate,
                width: '22%'
            }, {
                field: 'effectivePermission.principal',
                header: 'Applied To',
                cellTemplate: `<div class="latest-version">
									{{row.entity.effectivePermission.principal}}
								</div>`,
                width: '15%'
            }, {
                field: "effectivePermission.read",
                header: "Read",
                cellTemplate: this.JFrogTableViewOptions
                    .cellTemplateGenerators.booleanColumn('row.entity.effectivePermission.read','row.entity.name'),
                width: '10%',
                filterable: false
            }, {
                // IMPORTANT: in RT deploy === create (for release bundle only), so do not remove this
                field: "effectivePermission.deploy",
                header: "Create",
                cellTemplate: this.JFrogTableViewOptions
                    .cellTemplateGenerators.booleanColumn('row.entity.effectivePermission.deploy'),
                width: '10%',
                filterable: false
            }, {
                field: "effectivePermission.delete",
                header: "Delete",
                cellTemplate: this.JFrogTableViewOptions
                    .cellTemplateGenerators.booleanColumn('row.entity.effectivePermission.delete'),
                width: '10%',
                filterable: false
            }, {
                field: "effectivePermission.annotate",
                header: "Annotate",
                cellTemplate: this.JFrogTableViewOptions
                    .cellTemplateGenerators.booleanColumn('row.entity.effectivePermission.annotate'),
                width: '15%',
                filterable: false
            }, {
                field: "effectivePermission.distribute",
                header: "Distribute",
                cellTemplate: this.JFrogTableViewOptions
                    .cellTemplateGenerators.booleanColumn('row.entity.effectivePermission.distribute'),
                width: '15%',
                filterable: false
            }, {
                field: "effectivePermission.managedXrayMeta",
                header: "Manage Xray Meta",
                cellTemplate: this.JFrogTableViewOptions
                    .cellTemplateGenerators.booleanColumn('row.entity.effectivePermission.managedXrayMeta'),
                width: '20%',
                filterable: false,
                isVisible: () => this.AppContext.hasXray() && this.AppContext.hasXrayLicense()
            }, {
                field: "effectivePermission.managed",
                header: "Manage",
                cellTemplate: this.JFrogTableViewOptions
                    .cellTemplateGenerators.booleanColumn('row.entity.effectivePermission.managed'),
                width: '10%',
                filterable: false
            },
        ];
    }

    getDestinationsPermissionsColumns() {
        return [
            {
                field: 'permissionName',
                header: 'Permission Target',
                cellTemplate: this.nameCellTemplate,
                width: '22%'
            },
            {
                field: "jpus",
                header: "JPUs",
                cellTemplate: this.JFrogTableViewOptions
                    .cellTemplateGenerators.listableColumn('row.entity.jpus','row.entity.permissionName'),
                width:'20%',
                filterable: false
            }, {
                field: "distribute",
                header: "Distribute",
                cellTemplate: this.JFrogTableViewOptions
                    .cellTemplateGenerators.booleanColumn('row.entity.distribute'),
                width: '15%',
                filterable: false
            }, {
                field: "delete",
                header: "Delete",
                cellTemplate: this.JFrogTableViewOptions
                    .cellTemplateGenerators.booleanColumn('row.entity.delete'),
                width: '15%',
                filterable: false
            }, {
                field: "managed",
                header: "Manage",
                cellTemplate: this.JFrogTableViewOptions
                    .cellTemplateGenerators.booleanColumn('row.entity.managed'),
                width: '15%',
                filterable: false
            },
        ];
    }

    getPipelinesPermissionsColumns() {
        return [
            {
                field: "permissionName",
                header: "Permission Target",
                cellTemplate: this.nameCellTemplate,
                width: '22%'
            },
            {
                field: "pipelineSources",
                header: "Pipeline Sources",
                cellTemplate: this.JFrogTableViewOptions
                    .cellTemplateGenerators.listableColumn('row.entity.pipelineSources', 'row.entity.permissionName'),
                width: '30%',
                filterable: false
            },
            {
                field: "read",
                header: "Read",
                cellTemplate: this.JFrogTableViewOptions
                    .cellTemplateGenerators.booleanColumn('row.entity.read'),
                width: '8%',
                filterable: false
            },
            {
                field: "trigger",
                header: "Trigger",
                cellTemplate: this.JFrogTableViewOptions
                    .cellTemplateGenerators.booleanColumn('row.entity.trigger'),
                width: '14%',
                filterable: false
            },
            {
                field: "managed",
                header: "Manage",
                cellTemplate: this.JFrogTableViewOptions
                    .cellTemplateGenerators.booleanColumn('row.entity.managed'),
                width: '10%',
                filterable: false
            },
        ];
    }

    async _getPermissions() {
        this.groupPermissionsDao.get({groups: [this.groupname]}).$promise.then((data)=> {
            this.buildsPermissionsOptions.setData(data.buildPermissions);
            this.bundlesPermissionsOptions.setData(data.releaseBundlePermissions);

            this._fixDataFormat(data.repoPermissions).then((fixedData)=>{
                this.reposPermissionsOptions.setData(fixedData);
            });
        });
        if (this.AppContext.isDistributionUp()) {
            try {
                await this._getDestinationsGroupsData();
            } catch (e) {
                console.error(e);
            }
        }
        if (this.AppContext.isPipelinesUp()) {
            try {
                await this._getPipelinesGroupsData();
            } catch (e) {
                console.error(e);
            }
        }
    }

    async _getDestinationsGroupsData() {
        const payload = {
            users: [],
            groups: [this.groupname]
        };
        await this.disributionPermissionsDAO.getDestinationsEffectivePermissions(payload).$promise.then(response => {
            if (response && response.permissions && response.permissions.length) {
                this.destinationsPermissionsOptions.setData(
                    response.permissions.map(dest => new DestinationsEffectivePermissionModel(dest)));
            }
        });
    }

    async _getPipelinesGroupsData() {
        const payload = {
            users: [],
            groups: [this.groupname]
        };
        await this.pipelinesPermissionsDao.getPipelinesEffectivePermissions(payload).$promise.then(response => {
            const { effectivePermissions = [] } = response;
            this.pipelinesPermissionsOptions.setData(effectivePermissions);
        });
    }

    _fixDataFormat(data,defer = null) {
        defer = defer || this.$q.defer();
        if (this.reposData.locals && this.reposData.remotes) {
            data.forEach((record)=>{
                if (record.repoKeys && record.repoKeys.length === 1 && record.repoKeys[0] === 'ANY LOCAL') {
                    record.repoKeysView = 'ANY LOCAL';
                    record.reposList = angular.copy(this.reposData.locals);
                }
                else if (record.repoKeys && record.repoKeys.length === 1 && record.repoKeys[0] === 'ANY REMOTE') {
                    record.repoKeysView = 'ANY REMOTE';
                    record.reposList = angular.copy(this.reposData.remotes);
                }
                else if (record.repoKeys && record.repoKeys.length === 1 && record.repoKeys[0] === 'ANY DISTRIBUTION') {
                    record.repoKeysView = 'ANY DISTRIBUTION';
                    record.reposList = angular.copy(this.reposData.dists);
                }
                else if (record.repoKeys && record.repoKeys.length === 1 && record.repoKeys[0] === 'ANY') {
                    record.repoKeysView = 'ANY';
                    record.reposList = angular.copy(this.reposData.remotes).concat(this.reposData.locals).concat(this.reposData.dists);
                }
                else if (record.repoKeys) {
                    record.repoKeysView = record.repoKeys.join(', ');
                    record.reposList = angular.copy(record.repoKeys);
                }
            });
            defer.resolve(data);
        }
        else {
            this.$timeout(()=>{
                this._fixDataFormat(data,defer);
            })
        }
        return defer.promise;
    }

    updateGroup() {
        return this.$q((resolve, reject) => {
            let payload = angular.copy(this.groupdata);
            _.extend(payload, this.input);
            this.groupsDao.update({name: this.groupdata.groupName}, payload).$promise.then((data) => {
                this.savePending = false;
                this.ArtifactoryModelSaver.save();
                window.$vueRouter.push({ name: 'admin.management.groups' });
                window.store.dispatch('groupsManagement/FETCH_GROUPS');
                resolve();
            }).catch(()=> {
                this.savePending = false;
                reject();
            });
        });
    }

    createNewGroup() {
        return this.$q((resolve, reject) => {
            let payload = angular.copy(this.groupdata);
            payload.realm = this.DEFAULT_REALM;
            _.extend(payload, this.input);
            const onboardingStepName = 'create_groups';
            const isStepSuccessEnabled = window.store.getters['onboardingProcess/IS_STEP_SUCCESS_ENABLED'](onboardingStepName);
            this.groupsDao.create({ $suppress_toaster: isStepSuccessEnabled }, payload).$promise.then((data) => {
                this.savePending = false;
                this.ArtifactoryModelSaver.save();
                window.$vueRouter.push({ name: 'admin.management.groups' });
                window.store.dispatch('groupsManagement/FETCH_GROUPS')
                if (isStepSuccessEnabled) {
                    window.store.dispatch('onboardingProcess/ONBOARDING_STEP_SUCCESS', onboardingStepName);
                }
                resolve();
            }).catch((err) => {
                if(isStepSuccessEnabled && err.status >=400){
                    this.JFrogNotifications.create({
                        error: err.data.error ? err.data.error : err.data.errors[0].message,
                    })

                }
                this.savePending = false;
                reject();
            });
        });
    }

    save() {
        if (this.savePending) return;
        this.savePending = true;
        let actionResolved = null;
        if (this.mode === 'edit') {
            actionResolved = this.updateGroup();
        }
        if (this.mode === 'create') {
            actionResolved = this.createNewGroup();
        }
        actionResolved.then(() => {
            if(this.wasProjectAdminRoleChanged && this.shouldShowProjectAdminRole()) {
                this.toggleProjectAdmin()
            }
        });
    }

    isSaveDisabled() {
        return this.savePending || this.groupForm.$invalid;
    }

    onAdminPrivelegesChange(){
        if(this.groupdata.adminPrivileges){
            this.saveLastNewUsersCheckbox = this.groupdata.newUserDefault;
            this.groupdata.newUserDefault = false
            this.groupdata.watchManager = true;
            this.groupdata.reportsManager = true;
            this.groupdata.policyManager = true;
            this.projectAdmin = true;
        } else {
            this.groupdata.newUserDefault = this.saveLastNewUsersCheckbox;
        }
    }

    cancel() {
        window.$vueRouter.push({ name: 'admin.management.groups' });
    }
}



// WEBPACK FOOTER //
// ./states/admin/security/groups/group_form.controller.js